import styled from 'styled-components';

const StyledFileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 98px;
`;

export default StyledFileInputWrapper;
